import { CardElement } from '@stripe/react-stripe-js';
import React, { useMemo, useState } from 'react';

import { cn } from '@pray/shared/utils/styles';

import { colors } from '../../foundations';
import Text from '../Text/Text';

import styles from './CardInputField.module.scss';

export default function CardInputField({
  label,
  className = '',
  error = null,
  inputProps = null,
  onBlur = null,
  onFocus = null,
  ...props
}) {
  const [active, setActive] = useState(false);
  const options = useOptions();

  const classes = [styles.input, className];

  if (label) classes.push(styles.withLabel);

  const handleFocus = (event) => {
    setActive(true);
    if (onFocus) onFocus(event);
  };

  const handleBlur = (event) => {
    setActive(false);
    if (onBlur) onBlur(event);
  };

  const labelStyle = active ? styles.floating : '';
  const activeStyle = active && !error ? styles.inputWrapActive : '';
  const errorStyle = error ? styles.inputWrapError : '';

  return (
    <>
      <div
        data-id="inputWrap"
        className={cn(styles.inputWrap, labelStyle, activeStyle, errorStyle, inputProps?.className)}
      >
        {label && (
          <div data-tapeventadded="button-placeholder" className={styles.placeholder} role="none">
            {label}
          </div>
        )}
        <CardElement
          className={classes.join(' ')}
          options={options}
          onBlur={handleBlur}
          onFocus={handleFocus}
          {...props}
        />
      </div>
      {error && <Text className={styles.error}>{error}</Text>}
    </>
  );
}

const useOptions = () => {
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize: '16px',
          lineHeight: '24px',
          color: colors.$text_primary,
          fontFamily: 'Satoshi, sans-serif',
          '::placeholder': {
            color: colors.$text_secondary,
          },
        },
        invalid: {
          color: colors.$attention,
        },
      },
    }),
    []
  );

  return options;
};
